import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./multi_download_button.module.scss";

type DownloadLinkProps = {
  creationDate: Date;
  uri: string;
  isLatestVersion?: boolean;
};

export const DownloadLink = ({ creationDate, uri, isLatestVersion }: DownloadLinkProps): JSX.Element => {
  const { formatDate } = useDateFormatter();
  const { t } = useTranslation("bookingModule", { keyPrefix: "reports.manageReports.reports" });
  return (
    <a href={uri} className={css.link} target="_blank" rel="noreferrer" download>
      <span className={css.title}>{formatDate(creationDate)}</span>
      {isLatestVersion && <span>{t("table.latestVersion")}</span>}
    </a>
  );
};

export default DownloadLink;
